import React, { useContext } from 'react';
import { ShopperContext } from '../context/shopper';
import { useUtils } from "../hooks/useUtils";
import { useStyles } from "../hooks/useStyles";
import HeadingBuilder from './HeadingBuilder';
import CircleRow from './CircleRow'
import Table from 'react-bootstrap/Table';
import { useTranslation } from "react-i18next";

const CircleList = ( {circles, leaderBased = false} ) => {
  console.log('CL.js circles: ', circles);
  const { shopper, circleShoppers } = useContext(ShopperContext);
  const {
    s_by_identifier_xip_code,
    shopper_is_leader_of_these_circles,
    shopper_is_admin_of_these_circles,
    is_shopper_admin_of_some_circle
  } = useUtils();

  const { tableShowNarrow, textAlignLeft } = useStyles();
  const { t } = useTranslation();

  console.log('Circcircles', circles);
  const circlesList = circles
    .sort(s_by_identifier_xip_code)
    .map(circle => {
      console.log('c_before', circle);
      const c = {...circle};
      console.log('c_after', c);
      return <CircleRow key={c.id} circle = { c } />
  })
  console.log('CL.js CircleList: ', circlesList);

  const circlesShopperLeads =
    shopper_is_leader_of_these_circles({
      circles: circles,
      shopper_id: shopper.id
    });

  // If 'leaderBased' is true, then 'circles' is a list of circles that
  // the shopper leads. As such, shopper is admin of all of them so we
  // can return 'circles' as the list of 'circlesShopperAdmins'.
  // Otherwise, create a list of circles where shopper is listed as 'admin'.
  const circlesShopperAdmins =
    leaderBased
      ? circles
      : shopper_is_admin_of_these_circles({
          cShoppers: circleShoppers, shopper_id: shopper.id
        })

  const adminAndOrLeaderBasedMsg =
    circlesShopperLeads.length > 0
      // THEN the message will mention '#' and explain what it means.
      ? circlesShopperLeads.length === circlesShopperAdmins.length
        // THEN there are no circles where shopper is admin and not leader.
          ? t('circle.addCircle.leaderOfAllCircles')
            // The '#' means you are the Leader of this circle.
        // ELSE there are circles where shopper is admin and not the leader.
          : t('circle.addCircle.leadSomeAndAdminOthers')
            //The * indicates 'admin' authority. The # means 'admin' and Leader.
      // ELSE the message won't have any '#' chars, only need to explain '*'.
      : circlesShopperAdmins.length > 0
          ? t('circle.addCircle.adminOfSomeCircles')
            // The * indicates 'admin' authority for this circle.
          : '';

  return (
   <>
    <Table responsive striped bordered hover size="sm" style={tableShowNarrow}>
      <thead >
        <tr style={textAlignLeft}>
          <th>
            {t('circle.identifier.label')}
          </th>
          <th>
            <HeadingBuilder
              Size           = 'fw-bold'
              headingText    = {t('global.label.xipCode')}
              // Xip Code
              tippyAlertText = {t('circle.postal_code.quickTippyContent')}
              tippyText      = {t('circle.postal_code.quickTippyContent')}
              // Xip Code indicates where this Shopping Circle is active....
            />
          </th>
        </tr>
      </thead>
      <tbody style={textAlignLeft} >
        {circlesList}
      </tbody>
    </Table>

    {
      is_shopper_admin_of_some_circle({
        cShoppers: circleShoppers, shopper_id: shopper.id
      })
        ? <HeadingBuilder
            Size = 'h6'
            headingText = {adminAndOrLeaderBasedMsg}
            // If 'is_shopper_admin_of_some_circle' is true
            // then the Msg will contain some text.
          />
        : null
    }
   </>
  )
}

export default CircleList;
